export class GraphQLNoResultsError extends Error {
  constructor(graphQLErrors) {
    super();
    this.name = 'GraphQLNoResultsError';
    this.errors = graphQLErrors;
    this.message = 'GraphQL returned errors & no results';
    this.errorMessages = graphQLErrors.map(error => error.message);
  }
}